import axios from "../api/axiosInstance";

export const GetAllCity = async () => {
    return await axios.get("/City/GetCityList");
};

export const GetCityById = async (id) => {
    return await axios.get("/City/GetCityById", {
        params: { id }
    });
};

export const GetCitiesByProvince = async (provinceId) => {
    return await axios.get("/City/GetCitiesByProvince", {
        params: { provinceId }
    });
};

export const AddCity = async (model) => {
    return await axios.post("/City/AddCity", model);
};

export const UpdateCity = async (model) => {
    return await axios.post("/City/UpdateCity", model);
};

export const RemoveCity = async (id) => {
    return await axios.post("/City/RemoveCity", null, {
        params: { id }
    });
};